var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.79,16.79H0V0H16.79V16.79ZM2,14.79H14.79V2H2V14.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37,16.79H20.21V0h16.79V16.79Zm-14.79-2h12.79V2h-12.79V14.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.79,37H0V20.21H16.79v16.79Zm-14.79-2H14.79v-12.79H2v12.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37,37H20.21V20.21h16.79v16.79Zm-14.79-2h12.79v-12.79h-12.79v12.79Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbox);
export default __webpack_public_path__ + "static/media/lightbox.924f73883e27880e2d460f775bd05aef.svg";
export { ForwardRef as ReactComponent };